/*
 * @Author: cc
 * @Date: 2019-12-08 21:59:07
 * @LastEditTime: 2022-02-10 15:20:04
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\components\util\trsAudioVideoUpload\generalUpload.js
 * @Description: 媒体云音视频上传控件通用版本
 */

angular.module('trsAudioVideoUploadModule', ['trsAudioVideoDraftModule', 'trsUploadForXjModule'])
    .directive('trsAvUpload', ['$timeout', '$compile', 'publicToolService',
        function ($timeout, $compile, publicToolService) {
            return {
                scope: {
                    uploader: '=',
                    callback: '&',
                    // option: '=',
                }, // {} = isolate, true = child, false/undefined = no change
                restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
                // templateUrl: './components/util/trsAudioVideoUpload/upload.html',
                replace: false,
                link: function ($scope, iEle) {
                    publicToolService.getModeconfiguration('avUploader').then((config) => {
                        if (config.mode === 'general') {
                            require(['generalUpLoad'], function (Upload) {
                                let defaultOPT = {
                                    id: 'videoUploadBtn',
                                    accept: true,
                                    size: 900 * 1024 * 1024,
                                    extensions: 'mp4',
                                    chunkLimit: 1,
                                    mimeType: 'video/mp4',
                                    // mimeType: 'video/mp4,video/mpeg,video/x-msvideo,video/quicktime',
                                    chunkSize: 5 * 1024 * 1024,
                                    registerUrl: '/bigdata/mr/personal/2/uploadByTempPath?'
                                };
                                defaultOPT = angular.extend(defaultOPT, $scope.uploader);
                                let selector = '<input id="' + defaultOPT.id + '" style="display: none;" type="file"/>';
                                selector = $compile(selector)($scope);
                                iEle.append(selector);

                                /**
                                 * [init description]实例初始化
                                 * @param   {[type]}  opt  [opt description]
                                 * @return  {[type]}       [return description]
                                 */
                                Upload.init = function (opt) {
                                    opt = Object.assign(defaultOPT, opt);
                                    let example = new Upload();
                                    for (let key in opt) {
                                        example[key] = opt[key];
                                    }
                                    eventInt(example, opt);
                                    return example;
                                };

                                /**
                                 * [checkSize description]参数校验
                                 * @param   {[type]}  example  [example description]
                                 * @param   {[type]}  size     [size description]
                                 * @return  {[type]}           [return description]
                                 */
                                let checkSize = function (example, size) {
                                    if (size <= example.size) {
                                        return true;
                                    }
                                    example.onError({ content: '上传失败请检查文件大小', code: 4 });
                                };
                                let extensionsReg = '\\.' + defaultOPT.extensions
                                    .replace(/,/g, '$|\\.')
                                    .replace(/\*/g, '.*') + '$';
                                extensionsReg = new RegExp(extensionsReg, 'i');

                                /**
                                 * [checkExtensions description] 校验文件格式
                                 * @param   {[type]}  example    [example description]
                                 * @param   {[object]}  file     [file description] 文件格式
                                 * @return  {[type]}             [return description]
                                 */
                                let checkExtensions = function (example, file) {
                                    let examFlag = extensionsReg.test(file.name);
                                    if (examFlag) {
                                        return true;
                                    }
                                    example.onError({ content: '上传失败请检查文件格式', code: 5 });
                                };

                                /**
                                 * [eventInt description] 挂载事件
                                 * @param   {[type]}  example  [example description]
                                 * @param   {[type]}  opt      [opt description]
                                 * @return  {[type]}           [return description]
                                 */
                                let eventInt = function (example, opt) {
                                    let dom = document.getElementById(opt.id);
                                    if (dom) {
                                        dom.setAttribute('accept', opt.mimeType);
                                        dom.addEventListener('change', function (e) {
                                            const [file] = e.target.files;
                                            if (file) {
                                                if (checkSize(example, file.size) && checkExtensions(example, file)) {example.handleFileChange(e);}
                                            }
                                        });
                                    }
                                };
                                $scope.uploader = Upload.init(defaultOPT);

                                /**
                                 * [selectFile description]
                                 * @return  {[type]}  [return description]
                                 */
                                $scope.uploader.selectFile = function () {
                                    $timeout(function () {
                                        selector[0].value = null; // 解决选择同一视频不触发上传的问题
                                        selector.trigger('click'); // 模拟点击
                                    });
                                };
                            });
                            $scope.$on('$destroy', function () {
                                if ($scope.uploader) {
                                    $scope.uploader.handlePause();
                                    $scope.uploader = null;
                                }
                            });
                        }
                    });

                },
            };
        },
    ]);
